import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { ROUTES } from "@/routes/constants";
import { useMpiSearchActions } from "../stores";

export const useMpiFeatureBoundary = () => {
  const location = useLocation();
  const prevPathnameRef = useRef("");
  const { clearStore } = useMpiSearchActions();

  useEffect(() => {
    const prevPathname = prevPathnameRef.current;
    const currentPathname = location.pathname;
    const isWithinMpiFeature = currentPathname.startsWith(ROUTES.MPI);
    const wasWithinMpiFeature = prevPathname.startsWith(ROUTES.MPI);

    if (prevPathname && wasWithinMpiFeature && !isWithinMpiFeature) {
      clearStore();
    }

    prevPathnameRef.current = currentPathname;
  }, [clearStore, location.pathname]);
};
